import React from 'react';
import styles from './FormPageDisplay.scss';
import HeaderNavigation from '../../components/HeaderNavigation';
import SimpleButton from '../../components/SimpleButton';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'app/configureStore';
import TermAndConditionText from '../../components/TermAndConditionText';
import { CircularProgress } from 'drift-ui';

const TermsAndConditions = () => {
  const legalTexts = useSelector((state: RootState) => state.applicationReducer.legalTexts);

  const securityUcc = legalTexts?.find((text) => text.legal_type === 'securityUcc');
  const creditVerification = legalTexts?.find((text) => text.legal_type === 'creditVerification');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onHandleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className={styles.fixedHeader}>
        <HeaderNavigation />
      </div>

      <div className={styles.scrollableContent} style={{ marginTop: '130px' }}>
        <div className={styles.container}>
          <div className={styles.content}>
            {!securityUcc && !creditVerification ? (
              <CircularProgress />
            ) : (
              <>
                <TermAndConditionText {...securityUcc} />
                <TermAndConditionText {...creditVerification} />
              </>
            )}
            <SimpleButton text={t('back')} onClick={onHandleBack} />
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
